// extracted by mini-css-extract-plugin
export default {"All":"App_All__B3BEJ","Background":"App_Background__-xJDQ","Wrap":"App_Wrap__xAB1-","Box":"App_Box__tMV0A"};